import { faqData } from "../../data";

export default {
    name: 'faqTitleSection',
    title: 'FAQ Title Section',
    type: 'document',
    fields: [
        {
            name: 'title', title: 'Title', type: 'string', validation: Rule => Rule.required(),
            initialValue: faqData.title
        },
        {
            name: 'subtitle', title: 'Subtitle', type: 'text',
            initialValue: faqData.subtitle
        }
    ],
    preview: {
        select: {
            subtitle: 'subtitle'
        },
        prepare({ subtitle }) {
            return {
                title: 'FAQ Title Section',
                subtitle: subtitle || 'FAQ Title Section'
            }
        }
    }
} 